import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SearchStore {
  searchCount: number;
  chatCount: number;
  isSearchActive: boolean;
  isLoginRequired: boolean;
  isChatLoginRequired: boolean;
  searchContent: string;
  inputValue: string;
  searchLoginContent: string;
  isSearchTypeActive: boolean;
  showLoginPopup: boolean;
  isLoggedIn: boolean;

  setSearchActive: (active: boolean) => void;
  setSearchContent: (content: string) => void;
  setInputValue: (value: string) => void;
  setSearchLoginContent: (content: string) => void;
  setSearchTypeActive: (active: boolean) => void;
  incrementSearchCount: () => void;
  incrementChatCount: () => void;
  setLoginRequired: (required: boolean) => void;
  setChatLoginRequired: (required: boolean) => void;
  resetSearchCount: () => void;
  resetChatCount: () => void;
  setShowLoginPopup: (show: boolean) => void;
  setLoggedIn: (loggedIn: boolean) => void;
}

export const useSearchStore = create<SearchStore>()(
  persist(
    set => {
      const searchTrialLimit = parseInt(
        process.env.NEXT_PUBLIC_SEARCH_TRIAL_LIMIT ?? '3',
        10
      );

      return {
        searchCount: 0,
        chatCount: 0,
        isSearchActive: false,
        isSearchTypeActive: false,
        isLoginRequired: false,
        isChatLoginRequired: false,
        searchContent: '',
        searchLoginContent: '',
        showLoginPopup: false,
        isLoggedIn: false,
        inputValue: '',

        setInputValue: value => set({ inputValue: value }),
        setSearchActive: active => set({ isSearchActive: active }),
        setSearchContent: content => set({ searchContent: content }),
        setSearchLoginContent: content => set({ searchLoginContent: content }),
        setSearchTypeActive: active => set({ isSearchTypeActive: active }),
        incrementSearchCount: () =>
          set(state => {
            const newCount = state.searchCount + 1;

            const loginRequired = newCount >= searchTrialLimit;
            const isPopupTrigger = newCount >= 1;
            // const loginRequired = false;
            // const isPopupTrigger = false;

            console.log(
              '→ Zustand: newCount',
              newCount,
              'loginRequired',
              loginRequired
            );
            if (state.isLoggedIn) {
              return { searchCount: 0 };
            }

            return {
              searchCount: newCount,
              showLoginPopup: isPopupTrigger,
              isLoginRequired: loginRequired,
              // isLoggedIn: loginRequired,
            };
          }),

        incrementChatCount: () =>
          set(state => {
            const newCount = state.chatCount + 1;
            const chatTrialLimit = 2; // Require login after 2 chats

            console.log('→ Zustand Chat: newCount', newCount);
            if (state.isLoggedIn) {
              return { chatCount: 0, isChatLoginRequired: false };
            }

            // Enforce login after 2 chats
            const loginRequired = newCount >= chatTrialLimit;
            return {
              chatCount: newCount,
              isChatLoginRequired: loginRequired,
            };
          }),

        setLoginRequired: required => set({ isLoginRequired: required }),
        setChatLoginRequired: required =>
          set({ isChatLoginRequired: required }),
        setLoggedIn: loggedIn => set({ isLoggedIn: loggedIn }),

        resetSearchCount: () =>
          set({
            searchCount: 0,
            isLoginRequired: false,
            showLoginPopup: false,
          }),

        resetChatCount: () =>
          set({
            chatCount: 0,
            isChatLoginRequired: false,
          }),

        setShowLoginPopup: show => set({ showLoginPopup: show }),
      };
    },
    {
      name: 'search-store', // localStorage key - persists to browser storage
      // Explicitly persist critical fields but exclude login states
      partialize: state => ({
        searchCount: state.searchCount,
        chatCount: state.chatCount,
        // Don't persist login states - they should reset on each session
        // isLoginRequired: state.isLoginRequired,
        // isChatLoginRequired: state.isChatLoginRequired,
        // showLoginPopup: state.showLoginPopup,
        isLoggedIn: state.isLoggedIn,
        // Also persist other relevant fields
        searchContent: state.searchContent,
        searchLoginContent: state.searchLoginContent,
        inputValue: state.inputValue,
        isSearchTypeActive: state.isSearchTypeActive,
      }),
      // Add onRehydrateStorage to reset login states when store is hydrated
      onRehydrateStorage: () => state => {
        if (state) {
          // Reset login states on hydration (new session)
          state.isLoginRequired = false;
          state.isChatLoginRequired = false;
          state.showLoginPopup = false;
        }
        return state;
      },
    }
  )
);
